"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchOrganization = void 0;
const react_1 = require("react");
const useFetchOrganization = (user) => {
    const [orgUsers, setOrgUsers] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        const orgUsers = user.getOrganizations();
        setOrgUsers(orgUsers);
    }, []);
    return orgUsers;
};
exports.useFetchOrganization = useFetchOrganization;
